import { Link } from "react-router-dom";
import { Container, Input, Label, FormGroup, Row, Col } from "reactstrap";
import { Formik, Form } from "formik";
import Swal from 'sweetalert2'
import "./LandingComponent.css"
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Loading } from "./share/loading";
import { UpdateInformationComponent } from "./UpdateInformationComponent";

export default function LandingComponent() {
    const user = JSON.parse(localStorage.getItem("userData"))
    //console.log("user registerTypeId", user.registerTypeId);
    //console.log("user", user);

    const [borrowSystem, setBorrowSystem] = useState(false);
    const [supportSystem, setSupportSystem] = useState(false);
    //console.log("borrowSystem", borrowSystem);
    //.log("supportSystem", supportSystem);

    const [userSystem, setUserSystem] = useState(false);
    const [loading, setLoading] = useState(false);

    const Auth = () => {
        setLoading(true)
        try {
            if (user.roldId === "2") {
                for (let i = 0; i < user?.registerTypeId.length; i++) {

                    if (user?.registerTypeId[i] === 2) {
                        setBorrowSystem(true)

                    }
                    if (user?.registerTypeId[i] === 3) {
                        setBorrowSystem(true)
                        setSupportSystem(true)

                    }
                    if (user?.registerTypeId[i] === 6) {
                        setSupportSystem(true)
                    }
                    else {

                    }

                };
            } else if (user.roldId === "1") {
                if (user?.registerTypeId.length > 0) {
                    for (let i = 0; i < user?.registerTypeId.length; i++) {
                        //console.log("itemmm")
                        if (user?.registerTypeId[i] === 1) {
                            setBorrowSystem(true)
                            setSupportSystem(true)

                        }
                        if (user?.registerTypeId[i] === 2) {
                            setBorrowSystem(true)
                            setSupportSystem(true)
                        }
                        if (user?.registerTypeId[i] === 3) {
                            setBorrowSystem(true)
                            setSupportSystem(true)

                        }
                        if (user?.registerTypeId[i] === 4) {
                            setBorrowSystem(true)
                            setSupportSystem(true)

                        }
                        if (user?.registerTypeId[i] === 5) {
                            setBorrowSystem(true)
                            setSupportSystem(true)

                        }

                    }
                } else {

                }

            }
            else if (user.roldId === "3" || "4") {
                setBorrowSystem(true)
                setSupportSystem(true)
                setUserSystem(true)
            }
            else {

            }
        } catch (e) {

        } finally {
            setLoading(false);
        }



        return (

            <div>
                {loading ? (<Loading />) : (
                    <Container className="mt-5">
                        <Row className="justify-content-center">
                            {borrowSystem !== false ? (
                                <Col xs="12" sm="6" md="4" className="mb-4">
                                    <Link
                                        to="/borrowing/"
                                        style={{ textDecoration: "none" }}
                                        className="item-system d-flex justify-content-center align-items-center text-center" >
                                        <div
                                            className="d-flex flex-column justify-content-center align-items-center text-center">
                                            <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>ระบบการกู้ยืมเงิน<br />กองทุนพัฒนาฝีมือแรงงาน</span>
                                            <img src="images/Coins.png" width="100px" height="auto" alt="logo" />
                                        </div>
                                    </Link>
                                </Col>
                            ) : null}

                            {supportSystem !== false ? (
                                <Col xs="12" sm="6" md="4" className="mb-4">
                                    <Link
                                        to="/supporting/"
                                        style={{ textDecoration: "none" }}
                                        className="item-system d-flex justify-content-center align-items-center text-center" >
                                        <div
                                            className="d-flex flex-column justify-content-center align-items-center text-center">
                                            <span style={{ fontSize: "1.2rem", fontWeight: "bold", padding: "0 15px" }}>ระบบการให้เงินช่วยเหลือหรืออุดหนุน<br />กองทุนพัฒนาฝีมือแรงงาน</span>
                                            <img src="images/2hand.png" width="120px" height="auto" alt="logo" />
                                        </div>
                                    </Link>
                                </Col>
                            ) : null}

                            {user.roldId === "3" && userSystem && (
                                <>
                                    <Col xs="12" sm="6" md="4" className="mb-4">
                                        <Link
                                            to="/request/"
                                            style={{ textDecoration: "none" }}
                                            className="item-system d-flex justify-content-center align-items-center text-center" >
                                            <div
                                                className="d-flex flex-column justify-content-center align-items-center text-center">
                                                <span className="mt-4" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>จัดการบัญชีผู้ใช้งาน</span>
                                                <img src="images/Add-User-rafiki.png" width="120px" height="auto" alt="logo" />
                                            </div>
                                        </Link>
                                    </Col>
                                    <Col xs="12" sm="6" md="4" className="mb-4">
                                        <Link
                                            to="/request/consider-profile"
                                            style={{ textDecoration: "none" }}
                                            className="item-system d-flex justify-content-center align-items-center text-center" >
                                            <div className="d-flex flex-column justify-content-center align-items-center text-center">
                                                <span className="mt-4" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                                                    จัดการคำขอการเปลี่ยนข้อมูลส่วนตัว
                                                </span>
                                                <img src="images/user.png" width="90px" alt="logo" />
                                            </div>
                                        </Link>
                                    </Col>
                                </>

                            )}

                            <div class="boxes-tn">
                                <div></div> <div></div>
                                <div></div> <div></div>
                                <div></div> <div></div>
                                <div></div> <div></div>
                                <div></div>
                            </div>

                        </Row>
                    </Container>

                )}


            </div>
        );
    };

    const AcceptPrb = () => {
        Swal.fire({
            icon: "info",
            html: `ยอมรับและยืนยันการใช้ชื่อผู้ใช้และรหัสผ่าน<br/>ของระบบ PRB e-Service หรือไม่ ?`,
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {




            }
        });
    }

    return (
        <>
            {(user?.registerTypeId.length > 0 && user?.isUpdateInformation == false) || (user.roldId == "3" || user.roldId == "4") ? (
                <Auth />
            ) : (
                <Container className="mt-5" >
                    <Row className="justify-content-center">
                        <UpdateInformationComponent />
                    </Row>
                </Container >
            )
            }



        </>

    );

}

